import React, { useEffect, useMemo } from "react";

import { ProductPickerContext } from "@src/components/MainApp/SharedProductPicker/ProductPickerContext";
import { useSelector } from "@src/store";
import {
  getProductPickerFilters,
  getProductPickerSearch,
} from "@src/store/slices/productPicker";
import { ProductPickerProductDataSource } from "@src/store/slices/productPicker/util/ProductPickerProductDataSource";

interface ProductPickerProviderProps {
  children?: React.ReactNode;
  allowIgProducts?: boolean;
}

export const ProductPickerProvider = ({
  children,
  allowIgProducts,
}: ProductPickerProviderProps) => {
  const filters = useSelector(getProductPickerFilters);
  const search = useSelector(getProductPickerSearch);

  const context = useMemo(() => {
    return {
      dataSource: new ProductPickerProductDataSource(allowIgProducts ?? false),
    };
  }, [allowIgProducts]);

  context.dataSource.setFilters(filters);
  context.dataSource.setSearch(search);

  useEffect(() => () => context.dataSource.clear(), []);

  return (
    <ProductPickerContext.Provider value={context}>
      {children}
    </ProductPickerContext.Provider>
  );
};
